'use strict';

export const POST_MESSAGE_KEYS = {
	EVENT_GRID_SEND_FILTERS: 'EVENT_GRID_SEND_FILTERS',
    LOGIN_PARENT: 'LOGIN_PARENT',
    EVENT_GRID_COMMUNITY_FOOTER_ACTIONS: 'EVENT_GRID_COMMUNITY_FOOTER_ACTIONS',
    EVENT_GRID_OPEN_EVENT: 'EVENT_GRID_OPEN_EVENT',
};

export const IFRAME_APPS_IDS = {
    EVENT_GRID_IFRAME: '#iframe-event-grid',
};

export const POST_MESSAGE_ORIGINS = {
    EVENT_GRID_SEND_FILTERS: process.env.MANAGEMENT_URL,
    LOGIN_PARENT: window.location.origin,
    EVENT_GRID_COMMUNITY_FOOTER_ACTIONS: window.location.origin,
    EVENT_GRID_OPEN_EVENT: window.location.origin,
};


class PostMessageData {
    constructor(key, value) {
        this.with_key = key;
        this.with_value = value;
    }
    toJSON() {
        return {
            with_key: this.with_key,
            with_value: this.with_value
        };
    }
}

const validateMessageData = function (messageData) {
    return messageData && typeof messageData == 'object' 
        && 'with_key' in messageData 
        && 'with_value' in messageData 
        && POST_MESSAGE_KEYS[messageData.with_key];
}

const validateOrigins = function (origin) {
    return POST_MESSAGE_ORIGINS[origin] || false;
}

export const registerPostMessageListener = function (origin, key, callback) {
    console.log("registerPostMessageListener", origin, key);
    window.addEventListener('message', (event) => {
        console.log("Consumer received postMessage: ", event.data, "from: ", event.origin);
        // if (!validateOrigins(event.origin)) {
        //     console.error('Message origin is invalid: ' + event.origin);
        //     return;
        // }
        if (!validateMessageData(event.data)) {
            console.error('Message data is invalid: ', event.data);
            return;
        }
        if (event.data.with_key === key
            // && event.origin === origin        
        ) { 
            console.log("Consumer received postMessage: ", event.data, "from: ", event.origin);
            callback(event.data.with_value);
        }
    });
};

export const sendPostMessage = function (iframeId, origin, key, value) {
    console.log("Consumer sending postMessage: ", iframeId, origin, key, value);
    const postMessage = new PostMessageData(key, value);
    const iframe = $(iframeId)[0]; 
    if (iframe.contentWindow) {
        iframe.contentWindow.postMessage(postMessage.toJSON(), origin || '*');
    }
};
